// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../public/images/logo_image.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".head_title {\n  height: 67px;\n  color: rgb(48, 49, 51) !important;\n  font-size: 40px !important;\n}\n.suitability_home {\n  height: 25px;\n  color: rgb(96, 98, 102);\n  font-size: 18px;\n}\n.imgs_logo {\n  height: 25px;\n  width: 100px;\n  margin-top: -3%;\n  margin-left: 69%;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head_title": "head_title",
	"suitability_home": "suitability_home",
	"imgs_logo": "imgs_logo"
};
module.exports = ___CSS_LOADER_EXPORT___;
